__turbopack_context__.v({
  "page": "index-module__1oTOOa__page",
});
